import { ReactNode } from 'react';

import { useFormContext } from 'react-hook-form';

export const ConditionalRender = ({
  when,
  children,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  when: (val: Record<any, any>) => boolean;
  children: ReactNode;
}) => {
  const { watch } = useFormContext();
  const value = when(watch());

  return value ? children : null;
};
